import type { IDynamicControlSetting } from '~/presentation/reports/common/type';

import { EDimensionKey, EReportControlId, ERFilterKey } from '~/presentation/reports/common/type';
import { getDimensionSettingUIs } from '../utils';

export const DEFAULT_DIMENSIONS = [EDimensionKey.TIME];
export const DEFAULT_FILTER = [ERFilterKey.DATE];
export const DEFAULT_UI_PRESET: IDynamicControlSetting = {
  [EReportControlId.DIMENSIONS_FILTER]: {
    controls: getDimensionSettingUIs(DEFAULT_DIMENSIONS),
  },
};
